// Mirrors src/widgetLoaders/defaultWidgetList.js so the dashboard renders
// correctly when widgetPreferences is missing or has an empty userSchema. The
// `i` property is required for drag-drop reorder and React keys; the width and
// height fields drive the CSS Grid layout.
export const defaultWidgetsConfig = [
    {
        i: '0',
        type: 'main-kpis',
        kind: 'stripe',
        component: 'MainKpisStripeWidget',
        regularWidth: 12,
        smallWidth: 11,
        height: 108,
        w: 12,
        h: 108,
        x: 0,
        y: 0,
        static: true
    },
    {
        i: '1',
        type: 'revenue-chart',
        kind: 'chart',
        component: 'RevenueChartWidget',
        regularWidth: 6,
        smallWidth: 5,
        height: 360,
        w: 6,
        h: 360,
        x: 0,
        y: 108
    },
    {
        i: '2',
        type: 'platform-chart',
        kind: 'chart',
        component: 'PlatformChartWidget',
        regularWidth: 6,
        smallWidth: 5,
        height: 360,
        w: 6,
        h: 360,
        x: 6,
        y: 108
    },
    {
        i: '3',
        type: 'top-domains-chart',
        kind: 'chart',
        component: 'TopDomainsChartWidget',
        regularWidth: 6,
        smallWidth: 5,
        height: 360,
        w: 6,
        h: 360,
        x: 0,
        y: 468
    },
    {
        i: '4',
        type: 'top-adunits-grid',
        kind: 'grid',
        component: 'TopAdunitsGridWidget',
        regularWidth: 6,
        smallWidth: 5,
        height: 360,
        w: 6,
        h: 360,
        x: 6,
        y: 468
    }
];
